<template>
  <div class="container">
    <div class="el-tabs--border-card pb-3 border border-white rounded">
    <div id="loan-list">
      <section :class="['amount', '']">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="amount-item">
              <span class="amount-title">Unpaid Principal Amount</span>
              <!-- <span class="amount-title-en"></span> -->
              <span class="amount-money">
                <em>$</em>
                {{myLoanData.balancedPrincipal}}
              </span>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6">
            <div class="amount-item">
              <span class="amount-title">Total Amount Already Paid</span>
              <!-- <span class="amount-title-en"></span> -->
              <span class="amount-money">
                <em>$</em>
                {{myLoanData.recedSum}}
              </span>
            </div>
          </div>
        </div>
      </section>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6">
          <span class="info-card-item-ch">paid principal</span>
          <span class="info-card-item-num">${{myLoanData.recedPrincipal}}</span>
          <i class="vertical-line"></i>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6">
          <span class="info-card-item-ch">paid loan fee</span>
          <span class="info-card-item-num">${{myLoanData.recedInterest}}</span>
          <i class="vertical-line"></i>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6">
          <span class="info-card-item-ch">unpaid principal</span>
          <span class="info-card-item-num">${{myLoanData.balancedPrincipal}}</span>
          <i class="vertical-line"></i>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6">
          <span class="info-card-item-ch">unpaid interest</span>
          <span class="info-card-item-num">${{myLoanData.balancedInterest}}</span>
          <i class="vertical-line"></i>
        </div>
      </div>      
      <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6">
          <span class="info-card-item-ch">unpaid penalty</span>
          <span class="info-card-item-num">$0.00</span>
        </div>
          <div class="col-sm-12 col-md-12 col-lg-6">
          <span class="info-card-item-ch">paid penalty</span>
          <span class="info-card-item-num">$0.00</span>
        </div>
      </div>
      <br/>
      <section>
        <el-tabs :active-name="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="item in labelName"
            :label="item.label"
            :name="item.name"
            :frontApplyState="item.name"
            :key="item.name"
          ></el-tab-pane>
        </el-tabs>
        <router-view></router-view>
      </section>
    </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as types from "../../vuex/types";

export default {
  data() {
    return {
      labelName: [
        {
          label: "My Loans",
          name: "0"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      activeName: types.ACTIVE_NAME,
      userInfo: types.GET_USER,
      myLoanData: types.MY_LOAN_DATA,
      frontApplyState: types.FRONT_APPLY_STATE,
      isUseingLimit: types.IS_USEING_LIMIT
    })
  },
  methods: {
    ...mapMutations({
      setFrontApplyState: types.SET_FRONT_APPLY_STATE,
      setActiveName: types.SET_ACTIVE_NAME
    }),
    ...mapActions({
      getMyloanData: types.GET_MY_LOAN_DATA
    }),
    handleClick(tab) {
      this.setActiveName(tab.name);
      this.setFrontApplyState(tab.name);
      this.$router.push({
        path: "/personalCenter/myLoan/loanLists",
        query: { frontApplyState: this.frontApplyState, pageCount: 1 }
      });
    }
  },
  mounted() {
    this.getMyloanData({
      token: this.userInfo.token,
      frontApplyState: 0,
      pageCurrent: 1
    });
    this.$router.push({
      path: "/personalCenter/myLoan/loanLists",
      query: { frontApplyState: 0, pageCount: 1 }
    });
  }
};
</script>


<style lang='scss'>
#loan-list {
  position: relative;
  padding: 0 0 0 10px;
}

.amount {
  overflow: hidden;
  .amount-item {
    display: inline-block;
    height: 187px;
    width: 435px;
    overflow: hidden;
    margin-left: 11px;
    background: #fff url("#{$imagePath}/amount_bg.png") no-repeat center 126px;

    &:first-child {
      margin-left: 0;
    }

    .amount-title {
      margin-top: 40px;
      font-size: 18px;
      color: #35c4f9;
      font-family: "FZLanTingHei-DB-GBK";
    }

    .amount-title-en {
      margin-top: 7px;
      font-size: 13px;
      color: #3e454d;
      font-family: "MyriadPro-Regular";
    }

    .amount-money {
      margin-top: 10px;
      font-size: 30px;
      font-weight: bold;
      color: #34495e;
      font-family: "MyriadPro-Bold";

      em {
        font-style: normal;
        font-size: 26px;
        font-family: "Microsoft YaHei";
      }
    }
  }

  span {
    display: block;
    width: 100%;
    text-align: center;
  }
}

// 还没有贷款额度
.amount.is-useing-limit {
  .amount-item {
    width: 207px;
    margin-left: 15px;
    background: #fff url("#{$imagePath}/amount_bg2.png") no-repeat center 144px;

    &:first-child {
      margin-left: 0;
    }

    .ask-amount-btn {
      width: 92px;
      height: 30px;
      display: block;
      margin: 15px auto;
      border-radius: 2px;
      cursor: pointer;
      background: $orange;
      line-height: 30px;
      font-size: 14px;
      color: $white;
      font-family: "FZLanTingHei-B", "Microsoft YaHei";
    }
  }
}

.amount,
.info-card,
.loan-lists {
  position: relative;
  margin-top: 20px;
  width: 100%;
}

.info-card,
.repayment-amount,
.outstanding-amount,
.loan-lists {
  border-radius: 2px;
  background: #fff;
}

.loan-lists {
  margin-bottom: 20px;
}

//info-card块css
.info-card {
  height: 68px;
  line-height: 68px;
}

.info-card-item {
  float: left;
  margin: auto;
  width: 25%;
  vertical-align: middle;
}

.info-card-item-ch {
  margin-left: 30px;
  font-family: "FZLanTingHei-DB-GBK";
  text-align: center;
  font-size: 14px;
  color: #3e454d;
}

.info-card-item-num {
  padding-left: 10px;
  max-width: 90px;
  font-family: "Microsoft YaHei";
  font-size: 14px;
  color: #35c4f9;
}

.vertical-line {
  float: right;
  margin-top: 18px;
  width: 1px;
  height: 33px;
  border-right: 1px solid #e8e8e8;
}

@media (max-width: 768px) {
  .vertical-line {
    display: none;
  }
}
//loan-lists块css
//覆盖饿了么UI样式
#loan-list {
  .el-tabs__item {
    padding: 0 30px;
    font-size: 16px;
    /*padding:0;*/
    /*margin:0 30px;*/
    /*display: inline-block;*/
    color: #34495e;
    font-family: "FZLanTingHei-DB-GBK";
  }

  /*.el-tabs__item.is-active{*/
  /*border-bottom:2px solid #35c4f9;*/
  /*}*/

  .el-tabs__header {
    border-bottom: none;
  }

  .is-active {
    color: #35c4f9;
  }

  .el-tabs__active-bar {
    /*display: none;*/
    background-color: #35c4f9;
  }

  .el-tabs__active-bar {
    bottom: 3px;
    height: 0.1em;
  }
}
</style>



// WEBPACK FOOTER //
// MyLoan.vue?52f37448